<template>
  <div class="harness-wrap">
    <div class="harness-col">

      <!-- The card under review -->
      <ConsentCard
        :state="restoredState"
        @state-changed="onStateChanged"
        @request-advance="onRequestAdvance"
      />

      <!-- Placeholder for engine chrome: the real Start button is owned by the
           engine and gated on the card reporting valid. Here it does nothing
           beyond demonstrating the gating. -->
      <div class="chrome-footer">
        <button
          type="button"
          class="next-button"
          :disabled="!isValid"
          @click="onStart"
        >Quiz starten</button>
      </div>

    </div>
  </div>
</template>

<script>
import ConsentCard from './ConsentCard.vue';

export default {
  name: 'ConsentReviewHarness',
  components: { ConsentCard },
  data() {
    return {
      emittedState: null,
      restoredState: null,
    };
  },
  computed: {
    isValid() {
      return this.emittedState ? this.emittedState.valid === true : false;
    },
  },
  methods: {
    // The card emits its full state on every input or locale change. In Step 2
    // this is what the engine stores and later turns into a consent record.
    // Shape (see ConsentCard.emittedState):
    //   {
    //     path: 'self' | 'parent' | null,
    //     affirmations: { participation: true, research_data?: true },
    //     locale: 'en' | 'de' | 'fr' | 'it',
    //     valid: boolean
    //   }
    onStateChanged(state) {
      this.emittedState = state;
    },
    onRequestAdvance() {
      // Consent is a gated card and does not auto-advance, so this is not
      // expected to fire. Wired for contract completeness.
    },
    onStart() {
      // No real navigation in Step 1; gating is the only thing being shown.
    },
  },
};
</script>

<style scoped>
.harness-wrap {
  background: #f5f4ef;
  min-height: 100%;
  padding: 1.25rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  box-sizing: border-box;
}

.harness-col {
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
}

.chrome-footer {
  margin-top: 1rem;
}

.next-button {
  width: 100%;
  padding: 14px;
  background: #f1efe8;
  color: #888780;
  border: 0.5px solid rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  font-size: 15px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  cursor: not-allowed;
}

.next-button:not(:disabled) {
  background: #534AB7;
  color: white;
  border-color: #534AB7;
  cursor: pointer;
}

.next-button:not(:disabled):hover {
  opacity: 0.9;
}
</style>
